import { Label, Text } from '../../../../../styles/component.styles';

const ContactFormDisplay = () => {

  return (
    <>
      <Label>Contact Form</Label>
      <Text>This section renders the default contact form. Styling is fixed in V1 and cannot be changed.</Text>
    </>
  );
};

export default ContactFormDisplay;